import { render, staticRenderFns } from "./AccountDomainsDetail.vue?vue&type=template&id=7cd1dfad&"
import script from "./AccountDomainsDetail.vue?vue&type=script&lang=ts&"
export * from "./AccountDomainsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports